import { OPEN_SNACK, OPEN_SNACK_LOADING, OPEN_SNACK_ERROR, CLOSE_SNACK } from "../actions/type.action";

const initialState = {
  snackOpened: false,
  alertMessage: '',
  alertType: 'info',
  snackLoading: false,
  // hideDuration:5000
};

export const snackBarReducer = (state = initialState, action) => {
  // console.count('snack action');
  switch (action.type) {
  case OPEN_SNACK:
    return {
      ...state,
      snackOpened: true,
      alertType: action.payload.alertType,
      alertMessage: action.payload.alertMessage,
      snackLoading: false,
    };
  case OPEN_SNACK_LOADING:
    return {
      ...state,
      snackOpened: true,
      snackLoading: true,
      alertMessage: action.payload.alertMessage,
      alertType: action.payload.alertType || 'info',
      hideDuration:action.payload.hideDuration
    };
  case OPEN_SNACK_ERROR:
    return {
      ...state,
      snackOpened: true,
      alertType: 'warning',
      alertMessage: action.payload.alertMessage,
    };
  case CLOSE_SNACK:
    return { ...state, snackOpened: false }; 

  default:
    return state;
  }
};
